import { TrueformBrand } from '@trueform/ui/core';

/**
 * This app's brand — the single tenant-identity file. These are the only
 * brand literals in the application; shared code reads them through the
 * `TRUEFORM_BRAND` token instead of hardcoding them. A rebrand replaces this
 * file (and the i18n `brand/*.json` namespace) and nothing else.
 */
export const APP_TRUEFORM_BRAND: TrueformBrand = {
  name: 'Materias Primas',
  shortName: 'MatPrim',
  // Prefix for every localStorage key and the locale cookie.
  storagePrefix: 'matprim',
  // Placeholder mark (or the file copied via `--logo`); replace
  // `public/assets/logo.svg` with the real logo (keeping these intrinsic
  // sizes, or updating them).
  logo: {
    src: 'assets/logo.png',
    alt: 'Materias Logo',
    width: 240,
    height: 78,
  },
};
